import React from "react";
import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa6";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <h4>TeluguOne Services</h4>
           <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/news/"> » News</a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/tmdb/"> » Movie News</a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/movies/"> » Movies</a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/grandalayam/"> » Grandalayam</a>
         <a target="_blank" rel="noopener noreferrer" href="http://www.kidsone.in/"> » Kids One</a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/shortfilms"> » Short Films</a>
      
        </div>
        <div>
          <h4></h4>
          <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/photos"> » Photos</a>
          <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/health"> » Health</a>
         <a target="_blank" rel="noopener noreferrer" href="https://www.teluguonefoundation.in/index.html"> » Charity</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/comedy"> » Comedy</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/splevents/"> » Special Events</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/recipes/"> » Recipes</a>
        </div>
        <div>
          <h4></h4>
         
      
            <a target="_blank" rel="noopener noreferrer" href="https://www.teluguoneradio.com/"> » Web Radio (Tori)</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/videos"> » Videos</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/devotional"> » Bhakti</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/vanitha"> » Vanitha</a>
      <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/nri"> » Nri Corner</a>
       <a target="_blank" rel="noopener noreferrer" href="https://www.teluguone.com/sahityam/"> » Sahityam</a>

        </div>
        <div>
          <h4>Follow Us On</h4>
          <div className="footer-social-row">
            <a href="https://www.facebook.com/profile.php?id=61587106207168" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF size={15} /></a>
            <a href="https://www.youtube.com/user/teluguone" target="_blank" rel="noopener noreferrer" aria-label="YouTube"><FaYoutube size={17} /></a>
            <a href="https://www.instagram.com/teluguone/?hl=en" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram size={17} /></a>
          </div>
        </div>
      </div>
      <div className="footer-desclaimer">
        Disclaimer: All content included on this TeluguOne.com Portal including text, graphics, images,
         videos and audio clips, is the property of ObjectOne Information Systems Ltd. or our associates, 
         and protected by copyright laws. The collection, arrangement and assembly of all content on this 
         portal/ related channels is the exclusive property of ObjectOne Information Systems Ltd. or our 
         associates and protected by copyright laws.
      </div>
      <div className="container copy">
        © 2000 - {new Date().getFullYear()} , TeluguOne.com, All rights reserved.
      </div>
    </footer>
  );
}
